module.exports = __webpack_public_path__ + "img/gb-wls.e4b02942.svg";